import React, { Component } from 'react'
import { Route, BrowserRouter, Switch } from 'react-router-dom'
import CssBaseline from '@material-ui/core/CssBaseline'

import Frame from './views/frame'
import Home from './views/home'
import Bath from './views/bath'
import Day from './views/day'
import Staging from './views/staging'
import Landscaping from './views/landscaping'
import Contact from './views/contact'
import About from './views/about'
import Portfolio from './views/portfolio'

class App extends Component {
  state = {
    page: 'home'
  }

  renderPage = () => {
    switch(this.state.page){
      case 'home':
        return <Home />
      case 'bath':
        return <Bath />
      case 'day':
        return <Day />
      case 'staging':
        return <Staging />
      case 'landscaping':
        return <Landscaping />
      case 'contact':
        return <Contact />
      case 'portfolio':
        return <Portfolio />
      case 'about':
        return <About />
    }
  }

  render() {
    return (
      <main>
        <CssBaseline />
        <BrowserRouter>
          <Frame
            changePage = {page => {this.setState({page})}}
          >
            {this.renderPage()}
              {/* <Switch>
                <Route exact path="/bath" component={Bath} />
                <Route exact path="/day" component={Day} />
                <Route exact path="/staging" component={Staging} />
                <Route exact path="/landscaping" component={Landscaping} />
                <Route exact path="/contact" component={Contact} />
                <Route exact path="/portfolio" component={Portfolio} />
                <Route exact path="/about" component={About} />
                <Route path="*" component={Home} />
              </Switch> */}
          </Frame>
        </BrowserRouter>
      </main>
    );
  }
}

export default App;
